import React from "react";
import { useEffect } from "react";
import { useState } from "react";


export default function Navbar(props, ){
    const [title, setTitle] = useState('');
    // const [activeSection, setActiveSection] = useState("Home");

    // const [homeRef] = props.homeRef;
    // const [skillRef] = props.skillRef;
    // const [projectRef] = props.projectRef;

    
    useEffect(() => {
        // startTypingAnimation()
        console.log()
        let i = 0
        const strTitle = "./c0deslinger"
        setInterval(()=>{
            const char = strTitle.charAt(i)
            setTitle((state) => state+char)
            i++
        }, 200)

        //cek section
        // window.addEventListener('scroll', () => {
        //     if (window.scrollY > projectRef.current.offsetTop) {
        //         setActiveSection("Project");
        //         console.log("active session: Project");
        //     } else if(window.scrollY > skillRef.current.offsetTop) {
        //         setActiveSection("Skill");
        //         console.log("active session: Skill ");
        //     }else {
        //         setActiveSection("Home");
        //         console.log("active session: Home");
        //     }
        // });

    }, [])

    function NavItem (props) {
        
        console.log(props.currentPath)
        return (
        <>
            <a href={props.path} className='mx-3 hover:text-yellow-500 text-slate-700 text-md sm:text-lg font-semibold' >{props.title}</a>
        </>
    )
    }

    return (<>
        <div className="z-50 flex border-b-stone-200 py-3 sm:px-8 shadow-lg fixed top-0 w-full bg-white/60 backdrop-blur">
            <div className="hidden sm:visible sm:block flex-1 p-3 font-bold text-xl text-slate-600">{title}</div>
            <div className="flex-1 sm:p-3">
                <nav className='nav text-center sm:float-right'>
                    <NavItem title='Home' path='#home' currentPath={props.routePath} />
                    <NavItem title='Skill' path='#skill' currentPath={props.routePath} />
                    <NavItem title='Journey' path='#journey' currentPath={props.routePath} />
                    <NavItem title='Articles' path='#article' currentPath={props.routePath} />
                    <NavItem title='Portfolio' path='#portfolio' currentPath={props.routePath} />
                </nav>
            </div>
        </div>
    
    </>)
}